export default __webpack_public_path__ + "static/media/9.d9df43f4.png";